<template>
  <div class="manhole-content" v-loading="loading">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="deviceId" label="设备id"></el-table-column>
      <el-table-column prop="data" label="描述"></el-table-column>
      <el-table-column prop="type" label="状态">
        <template slot-scope="scope"
          ><span :style="{ color: arrTypeColor[scope.row.type] }">{{
            arrType[scope.row.type]
          }}</span></template
        >
      </el-table-column>
      <el-table-column prop="createTime" label="报警时间"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
  </div>
</template>

<script>
import manholeLogApi from "@/api/manhole/manholeLog";
export default {
  data() {
    return {
      arrType: ["正常", "打开", "松动", "正常"],
      arrTypeColor: ["#ff7c2e", "#F56C6C", "#E6A23C", "#67C23A"],
      loading: false,
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
      },
      cnt_all: 0,
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      manholeLogApi.manholeLogList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.manhole-content {
  width: 100%;
}
</style>